import { render, staticRenderFns } from "./SendEmailDialog.vue?vue&type=template&id=72cb1cd9&"
import script from "./SendEmailDialog.vue?vue&type=script&lang=js&"
export * from "./SendEmailDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports